import { useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 *
 * 画面遷移時にページのスクロール位置を必ず最上部にリセットするための共通コンポーネント。
 */
const ScrollToTop = () => {
  const location = useLocation();

  // ブラウザのスクロール位置復元を無効化
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // ルート遷移ごとにスクロール位置を最上部へリセット
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.key]);

  return null;
};

export default ScrollToTop;
